<template>
    <div id="color-picker" class="share-wrapper share-content" v-if="palette">
        <header class="gutter frame share-heading fade-in-up">
            <h1 class="share-title">{{ palette.name }}</h1>
        </header>
		
        <section v-if="palette.share_link" class="gutter frame share-field-container fade-in-up">
            <share-url :palette="palette"/>
        </section>

        <section class="wrapper gutter frame">
			<div class="swatch-card-list">
				<div 
					class="swatch-card stagger-in-up" 
					v-for="(swatch, index) in palette.getSwatches()" 
					@click="activeSwatch = swatch" 
					:key="'swatch' + index">
					<div class="swatch-card__color" :style="'background-color:' + getSwatchStyle(swatch)"></div>
					<p class="swatch-card__detail">
						<span class="swatch-card__name">{{ trim(swatch.name, 10) }}</span>
						<span class="swatch-card__hex">#{{ getHex(swatch) }}</span>
					</p>
				</div>
			</div>
        </section>

        <section class="gutter frame fade-in-up">
            <code-component :palette="palette"/>
        </section>
    </div>
</template>

<script>
    import { rgbCSS }    from "../../../Lib/helpers/cssOutput";
    import Palette       from "../Palette";
    import Color         from "../../../Lib/Color";
    import CodeComponent from "../../Code/Views/Components/CodeComponent";
    import ShareUrl      from "../../../App/Views/Components/ShareUrl";
    import ShareResource from "../ShareResource";
    import ActivePalette from "../Store/ActivePalette";
    import Swatch        from "../Swatch";
    import Transition    from "../../../Lib/Objects/Transition";
    import BaseView      from '../../../App/Views/BaseView.vue';
    import { TweenMax }  from 'gsap';

    export default {
        name      : "Share",
        components: { ShareUrl, CodeComponent },
        extends: BaseView,
        data() {
            return {
                palette     : null,
                activeSwatch: null
            }
        },
        methods   : {
            getSwatchStyle(swatch) {
                return rgbCSS(swatch.color);
            },
            getHex(swatch) {
                return Color.fromRGB(swatch.color).hex().value.substr(1);
            },

            setDataFromStore() {
                let activePalette = new ActivePalette();
                this.palette      = new Palette(activePalette.getPalette());
                this.activeSwatch = new Swatch(activePalette.getActiveSwatch());
            },
            setDataFromApi(params) {
                let shareResource = new ShareResource();

                shareResource.show(params.user_id, params.share_token).then(({ data: palette }) => {
                    this.palette      = new Palette(palette);
                    this.activeSwatch = this.palette.getSwatches()[0];
                });
            },

            animateElementsIn() {
                setTimeout(() => {
                    new Transition('.share-content', 0.5).fadeIn();
                    new Transition('.fade-in-up', 0.5).fadeInUp(32);
                    new Transition('.stagger-in-up', 0.5).staggerFadeInUp(32, 0.025);
                }, 0);
            },
            trim(string, maxLength) {
                let newString;
                if(string.length >= maxLength) {
                    return string.substr(0, maxLength) + "...";                  
                } else {
                    return newString = string;
                }
            },
        },
        mounted() {
            this.animateElementsIn();

            let params = this.$route.params;
            if(!params.user_id || !params.share_token) {
                this.setDataFromStore()
            }
            else {
                this.setDataFromApi(params);
            }
        }
    }
</script>

